<template>
    <div id="profile-page">
        <div class="container p-0">
            <div class="row">
                <div class="col-lg-8 col-sm-12">
                    <profile-section ref="profileSection" :shop="shop" />
                </div>
                <div class="col-lg-4 col-sm-12">
                    <gallery-section ref="gallerySection" />
                </div>
                <div class="col-sm-12">
                    <address-section ref="addressSection" :address="address" />
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import ProfileSection from "./partials/ProfileSection";
import AddressSection from "./partials/AddressSection";
import GallerySection from "./partials/GallerySection";

export default {
    name: "ProfilePage",
    components: {
        ProfileSection, AddressSection, GallerySection
    },

    computed: {
        address() {
            return this.shop.address || {};
        }
    },

    data: () => ({
        shop: {},
    }),

    methods: {
        initialize(shop) {
            this.shop = shop;
            this.$refs.gallerySection.initialize(shop.id);
        },
    },

    mounted() {
        this.$emit("mounted");
    }
}
</script>

<style lang="css" scoped>
    .page-heading {
        margin-bottom: 15px;
        padding: 0px 24px;
    }
</style>